/** */
export const ADD_ONE_WORD_SEARCH_TO_STORE = 'add one word search to store.';
export const ADD_MANY_WORD_SEARCHES_TO_STORE = 'add multiple word searches to store.';
export const REM_ONE_WORD_SEARCH_FROM_STORE = 'remove a word search from the store.';

/** */
export const addOneWordSearchToStore = (payload) => ({
  type: ADD_ONE_WORD_SEARCH_TO_STORE,
  payload
});

export const addManyWordSearchesToStore = (payload) => ({
  type: ADD_MANY_WORD_SEARCHES_TO_STORE,
  payload
});

export const removeOneWordSearchFromStore = (payload) => ({
  type: REM_ONE_WORD_SEARCH_FROM_STORE,
  payload
});
